import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import DateTimePicker from 'react-datetime'
import moment from 'moment'

class AlarmModalTimePicker extends Component {
  state = { keypadHoursInput: '', keypadMinutesInput: '' }

  componentDidMount() {
    this.hoursEl = document.querySelector(
      '.rdtCounters .rdtCounter:first-child .rdtCount'
    )
    this.minutesEl = document.querySelector(
      '.rdtCounters .rdtCounter:last-child .rdtCount'
    )

    this.hoursEl.addEventListener('click', (e) => {
      this.props.inputHoursRef.current.focus()
      this.props.setIsHoursPickerFocusedHandler(true, this.hoursEl)
      this.props.setIsMinutesPickerFocusedHandler(false, this.minutesEl)

      if (e) e.stopPropagation()
    })
    this.hoursEl.setAttribute('type', 'button')

    this.minutesEl.addEventListener('click', (e) => {
      this.props.inputMinutesRef.current.focus()
      this.props.setIsMinutesPickerFocusedHandler(true, this.minutesEl)
      this.props.setIsHoursPickerFocusedHandler(false, this.hoursEl)

      if (e) e.stopPropagation()
    })
    this.minutesEl.setAttribute('type', 'button')

    // Do not use buttons on mobile
    if (window.cordova) return

    const datePickerButtonsEl = [...document.getElementsByClassName('rdtBtn')]
    datePickerButtonsEl.forEach((btnEl) => btnEl.setAttribute('type', 'button'))

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return
      this.props.inputHoursRef.current.blur()
      this.props.inputMinutesRef.current.blur()
      this.props.setIsMinutesPickerFocusedHandler(false, this.minutesEl)
      this.props.setIsHoursPickerFocusedHandler(false, this.hoursEl)
    })
  }

  componentWillUnmount() {
    this.hoursEl.removeEventListener('click', (e) => {
      this.props.inputHoursRef.current.focus()
      this.props.setIsHoursPickerFocusedHandler(true, this.hoursEl)
      this.props.setIsMinutesPickerFocusedHandler(false, this.minutesEl)

      if (e) e.stopPropagation()
    })

    this.minutesEl.removeEventListener('click', (e) => {
      this.props.inputMinutesRef.current.focus()
      this.props.setIsMinutesPickerFocusedHandler(true, this.minutesEl)
      this.props.setIsHoursPickerFocusedHandler(false, this.hoursEl)

      if (e) e.stopPropagation()
    })

    if (window.cordova) return

    document.removeEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return
      this.props.inputHoursRef.current.blur()
      this.props.inputMinutesRef.current.blur()
      this.props.setIsMinutesPickerFocusedHandler(false, this.minutesEl)
      this.props.setIsHoursPickerFocusedHandler(false, this.hoursEl)
    })
  }

  keypadHoursEntryHandler = ({ target: { value } }) => {
    const stringVal = String(value)
    const valLength = stringVal.length
    const numVal = parseInt(value)
    const isNotANumber = !numVal && numVal !== 0 && valLength !== 0

    if (
      stringVal.length > 2 ||
      stringVal.includes('-') ||
      stringVal.includes('.') ||
      isNotANumber
    )
      return

    if (valLength === 1 && numVal > 2) return

    const hours = moment(
      valLength === 1 ? `${stringVal}${this.props.selectedTime[1]}` : stringVal,
      'HH'
    )
    if (!hours.isValid()) return
    const hh = hours.format('HH')
    this.setState({ keypadHoursInput: stringVal })
    this.props.selectHoursHandler(hh)

    if (valLength === 1) return
    this.props.inputHoursRef.current.blur()
    this.props.setIsHoursPickerFocusedHandler(false, this.hoursEl)

    this.props.inputMinutesRef.current.focus()
    this.props.setIsMinutesPickerFocusedHandler(true, this.minutesEl)
  }

  keypadMinutesEntryHandler = ({ target: { value } }) => {
    const stringVal = String(value)
    const valLength = stringVal.length
    const numVal = parseInt(value)
    const isNotANumber = !numVal && numVal !== 0 && valLength !== 0

    if (
      stringVal.length > 2 ||
      stringVal.includes('-') ||
      stringVal.includes('.') ||
      isNotANumber
    )
      return

    const minutes = moment(
      valLength === 1 ? `${stringVal}${this.props.selectedTime[4]}` : stringVal,
      'mm'
    )
    if (!minutes.isValid()) return

    const mm = minutes.format('mm')

    this.setState({ keypadMinutesInput: stringVal })
    this.props.selectMinutesHandler(mm)

    if (valLength === 1) return
    this.props.inputMinutesRef.current.blur()
    this.props.setIsMinutesPickerFocusedHandler(false, this.minutesEl)
  }

  render() {
    return (
      <Fragment>
        <input
          className="alarm_timepicker_keypad_entry"
          type="number"
          maxLength={2}
          value={this.state.keypadHoursInput}
          onChange={this.keypadHoursEntryHandler}
          ref={this.props.inputHoursRef}
          onBlur={() => this.setState({ keypadHoursInput: '' })}
        />
        <input
          className="alarm_timepicker_keypad_entry"
          type="number"
          maxLength={2}
          value={this.state.keypadMinutesInput}
          onChange={this.keypadMinutesEntryHandler}
          ref={this.props.inputMinutesRef}
          onBlur={() => this.setState({ keypadMinutesInput: '' })}
        />
        <DateTimePicker
          className={`alarm_timepicker ${window.cordova ? 'is_mobile' : ''}`}
          timeFormat="HH:mm"
          dateFormat={false}
          value={this.props.selectedTime}
          onChange={(momentObj) => (
            console.log('change!'),
            this.props.selectTimeHandler(momentObj.format('HH:mm'))
          )}
          input={false}
        />
      </Fragment>
    )
  }
}

export default AlarmModalTimePicker

AlarmModalTimePicker.propTypes = {
  inputHoursRef: PropTypes.object.isRequired,
  inputMinutesRef: PropTypes.object.isRequired,
  selectMinutesHandler: PropTypes.func.isRequired,
  selectHoursHandler: PropTypes.func.isRequired,
  selectedTime: PropTypes.string.isRequired,
  setIsHoursPickerFocusedHandler: PropTypes.func.isRequired,
  setIsMinutesPickerFocusedHandler: PropTypes.func.isRequired,
}
